import { Injectable } from '@angular/core'
import { BaseModelService } from '../base-model.service'
import { OnlineInterviewerShedule } from './online-interviewer-schedule.model'
import { OnlineInterviwerScheduleSerializer, UserSerializer, OnlineInterviwerSchedulePeriodSerializer, OnlineInterviwerScheduleShiftSerializer } from 'serializers'
import { User, OnlineInterviewerShedulePeriod } from 'models'
import { Observable } from 'rxjs'
import { URLSearchParams } from '@angular/http'
import { CalendarBuildParams } from 'pages/admin/online-interviewer-schedules/calendar.component'
import { OnlineInterviewerSheduleShift } from './online-interviewer-schedule-shift.model'

@Injectable()
export class OnlineInterviewerSheduleService extends BaseModelService<OnlineInterviewerShedule> {
  constructor() {
    super()

    this.configure({
      basePath:  'online_interviewer_schedules',
      key:       'schedule',
      pluralKey: 'schedules',
      serializer: OnlineInterviwerScheduleSerializer
    })
  }

  interviewers(): Observable<User[]> {
    const url = this.buildUrl('interviewers')
    return this.appHttp.get(url).map(resp => {
      let rawData = resp.json()

      return rawData["interviewers"].map((interviewerData: Object) => UserSerializer.deserialize(interviewerData))
    })
  }

  calendar(scheduleId: number, params: CalendarBuildParams): Observable<{
    periods: OnlineInterviewerSheduleShift[]
  }[]> {
    const url = this.buildUrl(scheduleId, "calendar")
    const search = new URLSearchParams()
    for (let key in params) {
      search.set(key, params[key].toString())
    }
    return this.appHttp.get(url, { search }).map(resp => {
      const days = resp.json()["days"]

      return days.map(dayJson => {
        if (dayJson == null) {
          return null
        } else {
          return {
            shifts: dayJson["shifts"].map(shiftJson => OnlineInterviwerScheduleShiftSerializer.deserialize(shiftJson))
          }
        }
      })
    })
  }

  calendarDay(scheduleId: number, unix: number = null): Observable<OnlineInterviewerShedulePeriod[]> {
    const url = this.buildUrl(scheduleId, "day")
    const search = new URLSearchParams()
    if (unix) search.set("ts", unix.toString())

    return this.appHttp.get(url, { search }).map(resp => {
      const periods = resp.json()["periods"]

      return periods.map(periodJson => OnlineInterviwerSchedulePeriodSerializer.deserialize(periodJson))
    })
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/online-interviewer-schedule/online-interviewer-schedule.service.ts